/**
 * <disclaimer-note> — the standing disclaimer.
 *
 * ⚠ **Visible, permanent, and not a gate.** 00-INDEX.md § Truth-telling is
 * explicit: no computation is hidden, there is no "are you sure" interstitial,
 * no age wall and no hedging away of a finding. This is a plain statement of
 * what the site is, shown on every page — which is a different thing from a
 * warning about what it might say.
 *
 * ◆ It is also not a legal shield dressed as humility. It says three true
 * things: everything is computed in the browser, the computation is checkable,
 * and Jyotiṣa is a traditional discipline rather than a prediction engine.
 *
 * © Manish Jagdish Thatte
 */

import { onLocaleChange, t } from '../utils/i18n.js';

/** The message in the reader's language, or the English below if the key has not loaded. */
function say(key, english) {
  const got = t(key);
  return got && got !== key ? got : english;
}

export class DisclaimerNote extends HTMLElement {
  connectedCallback() {
    this.unsub = onLocaleChange(() => this.render());
    this.render();
  }

  disconnectedCallback() { this.unsub?.(); }

  render() {
    this.textContent = '';

    const note = document.createElement('div');
    note.className = 'disclaimer';

    const p1 = document.createElement('p');
    p1.textContent = say('disclaimer.p1',
      'Everything here is computed in your browser from the astronomy of the moment ' +
      'you enter. Nothing is sent anywhere, and every chart carries the ayanāṁśa, ' +
      'house system and node it was computed with, so it can be checked against any ' +
      'other source.');

    const p2 = document.createElement('p');
    p2.textContent = say('disclaimer.p2',
      'This is Jyotiṣa as the classical texts state it, with the source cited where ' +
      'one exists. It is a traditional discipline, not a prediction service, and it ' +
      'is not a substitute for medical, legal or financial advice.');

    note.append(p1, p2);
    this.append(note);
  }
}

customElements.define('disclaimer-note', DisclaimerNote);
